import { memo } from 'react';
import { CloudArrowDownIcon } from '@heroicons/react/24/outline';
import { T } from '../../translation/src';
import classNames from 'classnames';

interface NavVisCardProps {
  onClick: () => void;
}

const NavVisCard_: React.FC<NavVisCardProps> = ({ onClick }) => {
  return (
    <div
      className={classNames(
        'flex items-center justify-center px-6 pt-5 pb-6 mt-1 border-2 border-dashed rounded-md cursor-pointer',
        'border-gray-300 dark:border-gray-400 hover:border-indigo-500 dark:hover:border-neon-green-400 transition-colors',
      )}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick();
        }
      }}
    >
      <div className="space-y-1 text-center">
        <CloudArrowDownIcon className="w-12 h-12 mx-auto text-gray-400 dark:text-gray-300" />
        <div className="flex flex-col text-sm text-gray-600 dark:text-gray-400">
          <div className="relative font-medium text-indigo-600 rounded-md focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:text-indigo-500 dark:text-neon-green-400 dark:hover:text-neon-green-500">
            <span>
              <T _str="Load NavVis IVION point cloud" />
            </span>
          </div>
        </div>
        <p className="text-xs text-gray-500">
          <T _str="Import from NavVis IVION" />
        </p>
      </div>
    </div>
  );
};

export const NavVisCard = memo(NavVisCard_);
